module.exports = __webpack_public_path__ + "static/media/gender-men-primary.97295295.svg";